import {
  GenerateRequest,
  GenerateResponse,
  SummarizeChangeLogsRequest,
  SummarizeChangeLogsResponse
} from '@app/types';
import { IHttpService } from './http-service';
import { HttpMethod } from './types';

export class GeminiService {
  static readonly baseUrl = '/api/gemini';

  private _httpService: IHttpService;

  constructor(httpService: IHttpService) {
    this._httpService = httpService;
  }

  async generate(
    request: GenerateRequest,
    signal?: AbortSignal
  ): Promise<GenerateResponse> {
    return this._httpService.fetchJsonOrFail({
      body: request,
      method: HttpMethod.post,
      signal,
      url: 'generate'
    });
  }

  /**
   * Summarize a list of commit / save messages into a single short paragraph.
   * Used by the merge dialog to give reviewers a high-level digest of every
   * change being merged in.
   */
  async summarizeChangeLogs(
    request: SummarizeChangeLogsRequest,
    signal?: AbortSignal
  ): Promise<SummarizeChangeLogsResponse> {
    return this._httpService.fetchJsonOrFail({
      body: request,
      method: HttpMethod.post,
      signal,
      url: 'summarize-change-logs'
    });
  }
}
